import { compose, mdsWidget } from 'dojo/_base/declare';
import widgetBase from 'dijit/_WidgetBase';
import templatetedMixin from 'dijit/_TemplatedMixin';
import widgetsInTemplateMixin from 'dijit/_WidgetsInTemplateMixin';
import template from './templates/MainForm.html?raw';
import RequestManager from 'more/RequestManager';
import MusicianProjectsMain from './MusicianProjectsMain';
import FunctionHeadDispoMain from './FunctionHeadDispoMain';
import TravelExpenseHome from '../TravelExpenses/TravelExpenseHome';
import domConstruct from 'dojo/dom-construct';
import lang from 'dojo/_base/lang';
import methodHooks from 'more/mdsMethodHooks';
// NOTE (JS2TS): dropped deps: dgrid/Grid (vendor lib, imported but never used in code + no ambient types),
// _base/connect (dead). $ (jQuery) is a runtime global used verbatim; declared ambiently.
declare const $: any;

class MainForm extends methodHooks(compose(widgetBase, templatetedMixin, widgetsInTemplateMixin)) {
    [key: string]: any;

    templateString: any = template;

    _setSiteActionAttr(value: any): void {
        console.log("Mainform Siteaction = " + value);

        value = value.toLowerCase();

        let view = null;

        if (value == "index") {
            view = new MusicianProjectsMain();
        } else if (value == "functionhead") {
            view = new FunctionHeadDispoMain();
        } else if (value == "travelexpenses") {
            view = new TravelExpenseHome();

        }
        else {
            // error
        }

        if (view == null) {
            console.error("invalid view-widget?!", value);
            return;
        }

        domConstruct.place(view.domNode, this.mainContentNode);

        view.startup();
    }

    _checkExistingSession(): void {

        var url = window.appRoot + "session/CheckForExistingSession";

        var req = new RequestManager();

        req.post(
            url,
            {

            },
            lang.hitch(this, "_onCheckExistingSessionResult"),
            lang.hitch(this, "_onCheckExistingSessionError"),
            false // sync
        );

    }

    _onCheckExistingSessionResult(result: any): void {

        var response = result;

        if (response.Exception == false) {
            try {
                $("#top_Username").html(response.UserDisplayName);
                $("#top_login_info").removeClass("w3-hide");
            } catch (ex) {

            }
        }
        else {
            try {
                $("#top_login_info").addClass("w3-hide");
                $("#top_Username").html(null);
            } catch (ex) {

            }
        }
    }

    _onCheckExistingSessionError(error: any): void {
        console.warn("checking session failed: ", error.Message);
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
        this._checkExistingSession();
    }

    postMixInProperties(): void {

    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
MainForm.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.MainForm';

export default mdsWidget(MainForm);
